import React, { FC } from 'react'

import styles from './ProjectDetailForm.module.scss'

export const ProjectDetailFormSkeleton: FC = () => (
  <>
    <section className={styles.section}>
      <div className={styles.labelSkeleton} />
      <div className={styles.inputSkeleton} />
      <div className={styles.labelSkeleton} />
      <div className={styles.inputSkeleton} />
      <div className={styles.labelSkeleton} />
      <div className={styles.inputSkeleton} />
    </section>
    <section className={styles.section}>
      <div className={styles.labelSkeleton} />
      <div className={styles.inputSkeleton} />
      <div className={styles.labelSkeleton} />
      <div className={styles.inputSkeleton} />
      <div className={styles.labelSkeleton} />
      <div className={styles.inputSkeleton} />
    </section>
  </>
)
